import React, { useState } from 'react';
import { FiChevronDown } from "react-icons/fi";

const TravelDetails = ({ form, setFormField, index, updateAirports }) => {
  const [isCheck, setIsCheck] = useState(false);

  return (
    <div className="mx-auto rounded-2xl shadow-md bg-white border border-slate-200 overflow-hidden mt-5">
      {/* Header bar */}
      <div className="bg-gradient-to-r from-primary from-[80%] to-secondary px-6 py-4 text-white font-semibold text-lg md:text-xl flex justify-between items-center">
        <span>Flight Details</span>

        {/* Toggle Pill in Header */}
        <div className="flex bg-[#001D16]/50 p-1 rounded-xl border border-white/10 select-none">
          <button
            type="button"
            className={`px-4 py-1.5 rounded-lg text-sm font-semibold transition-all duration-200 ${isCheck
                ? "bg-secondary text-primary shadow-sm"
                : "bg-transparent text-white/80 hover:text-white"
              }`}
            onClick={() => setIsCheck(true)}
          >
            Yes
          </button>
          <button
            type="button"
            className={`px-4 py-1.5 rounded-lg text-sm font-semibold transition-all duration-200 ${!isCheck
                ? "bg-secondary text-primary shadow-sm"
                : "bg-transparent text-white/80 hover:text-white"
              }`}
            onClick={() => setIsCheck(false)}
          >
            No
          </button>
        </div>
      </div>

      <div className="p-3 md:p-6">
        <p className="text-sm font-medium text-slate-500 mb-4">
          Do you have Terminal and flight details?
        </p>

        {/* Conditionally render form with transition */}
        <div
          className={`transition-all duration-500 ease-in-out overflow-hidden ${isCheck ? 'opacity-100 max-h-[500px]' : 'opacity-0 max-h-0'
            }`}
        >
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="grid grid-cols-1 gap-5 md:grid-cols-2">

              {/* Departure Terminal */}
              <div>
                <label className="block mb-1.5 text-sm font-semibold text-slate-700">Departure Terminal*</label>
                <div className="relative w-full">
                  <select
                    className="w-full px-4 py-3 bg-slate-100 text-slate-800 rounded-xl focus:outline-none border-2 border-transparent focus:border-primary/20 focus:bg-white appearance-none transition-all placeholder:text-slate-400 font-medium"
                    value={form.departure_terminal}
                    onChange={(e) => setFormField("departure_terminal", e.target.value)}
                  >
                    <option value="" className="text-slate-400">departure terminal</option>
                    {updateAirports[index]?.terminal?.map((o, i) => (
                      <option key={`dep-t-${i}`} value={o.name} className="text-slate-800">
                        {o.name}
                      </option>
                    ))}
                  </select>
                  <FiChevronDown className="absolute w-5 h-5 -translate-y-1/2 pointer-events-none right-4 top-1/2 text-primary" />
                </div>
              </div>

              {/* Departure Flight No */}
              <div>
                <label className="block mb-1.5 text-sm font-semibold text-slate-700">Departure Flight No*</label>
                <input
                  type="text"
                  className="w-full px-4 py-3 bg-slate-100 text-slate-800 rounded-xl focus:outline-none border-2 border-transparent focus:border-primary/20 focus:bg-white transition-all placeholder:text-slate-400 font-medium"
                  placeholder="Departure Flight No (TBC)"
                  name="Departure"
                  value={form.departure_flight_no}
                  onChange={(e) => setFormField("departure_flight_no", e.target.value)}
                />
              </div>

              {/* Arrival Terminal */}
              <div>
                <label className="block mb-1.5 text-sm font-semibold text-slate-700">Arrival Terminal*</label>
                <div className="relative w-full">
                  <select
                    className="w-full px-4 py-3 bg-slate-100 text-slate-800 rounded-xl focus:outline-none border-2 border-transparent focus:border-primary/20 focus:bg-white appearance-none transition-all placeholder:text-slate-400 font-medium"
                    value={form.arrival_terminal}
                    onChange={(e) => setFormField("arrival_terminal", e.target.value)}
                  >
                    <option value="" className="text-slate-400">arrival terminal</option>
                    {updateAirports[index]?.terminal?.map((o, i) => (
                      <option key={`arr-t-${i}`} value={o.name} className="text-slate-800">
                        {o.name}
                      </option>
                    ))}
                  </select>
                  <FiChevronDown className="absolute w-5 h-5 -translate-y-1/2 pointer-events-none right-4 top-1/2 text-primary" />
                </div>
              </div>

              {/* Arrival Flight No */}
              <div>
                <label className="block mb-1.5 text-sm font-semibold text-slate-700">Arrival Flight No*</label>
                <input
                  type="text"
                  className="w-full px-4 py-3 bg-slate-100 text-slate-800 rounded-xl focus:outline-none border-2 border-transparent focus:border-primary/20 focus:bg-white transition-all placeholder:text-slate-400 font-medium"
                  placeholder="Arrival Flight No (TBC)"
                  name="Return"
                  value={form.arrival_flight_no}
                  onChange={(e) => setFormField("arrival_flight_no", e.target.value)}
                />
              </div>

            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default TravelDetails;
